import React from 'react';
import { DetailedFiltersWrapper } from './styles';
import { MultiSelect } from '../../multiselect/MultiSelect';
import { FiltersObject } from '../../../utils/filterUtils';
import { useTranslations } from 'next-intl';

type DetailedFilterRowProps = {
    isDisabled: boolean;
    filters: FiltersObject;
    setFilters: (newFilters: FiltersObject) => void;
};

const DetailedFilterRow = ({ isDisabled, filters, setFilters }: DetailedFilterRowProps) => {
    const t = useTranslations('filtering');

    const options = ['yes', 'no'].map((x) => ({
        id: x,
        label: t(x as 'yes' | 'no'),
        isSelected: filters.example.includes(x)
    }));

    const updateFilterObject = (partialFilterObject: Partial<FiltersObject>) => {
        setFilters({
            ...filters,
            ...partialFilterObject
        });
    };

    const handleChange = (_selectedIDs: string[]) => {
        updateFilterObject({});
    };

    return (
        <DetailedFiltersWrapper>
            <MultiSelect
                name='example'
                allOptions={options}
                placeHolder={'Example Filter'}
                onChange={handleChange}
                disabled={isDisabled}
                shouldKeepPlaceholder={true}
            />
        </DetailedFiltersWrapper>
    );
};

export { DetailedFilterRow };
